"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleHeroWithMedia = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const primitives_richproducts_1 = require("@ariessolutionsio/primitives-richproducts");
const classNames_1 = require("../../../../utils/classNames");
const LinkButton_1 = require("../../../atomic/atoms/LinkButton");
const Typography_1 = require("../../../atomic/atoms/Typography");
const MediaRenderer_1 = require("../../../atomic/templates/MediaRenderer");
const ReferenceLink_1 = require("../../../atomic/templates/ReferenceLink");
const SimpleHeroWithMedia = (props) => {
    const { data: { darkMode, eyebrow, title, description, theme, background, callToAction, backgroundColor, backgroundLinkRightPanel, alignImageRight = true, }, extendedClasses, } = props;
    const bgColor = backgroundColor === 'transparent' ? backgroundColor : `#${backgroundColor}`;
    const media = background?.media;
    const ctaPalette = theme !== 'double_tree' ? 'primary' : 'orange';
    let themeStyles = {
        mediaHeight: extendedClasses?.mediaHeight || '',
        contentBox: extendedClasses?.contentBox || 'py-8 px-6',
        titleStyle: extendedClasses?.title,
        descriptionStyle: extendedClasses?.description,
        eyebrowStyle: extendedClasses?.eyebrow,
        ctaStyle: {
            style: extendedClasses?.cta || 'pr-8 mt-10 sm:flex',
            palette: ctaPalette,
        },
        ctaLabelStyle: extendedClasses?.ctaLabelStyle || '',
    };
    switch (theme) {
        case 'double_tree':
            {
                const titleFontColor = darkMode
                    ? 'text-white'
                    : bgColor === '#ffffff'
                        ? 'text-[#09194E]'
                        : 'text-[#A3CD39]';
                const descFontColor = bgColor === '#ffffff' ? 'text-[#000000]' : 'text-white';
                themeStyles = {
                    mediaHeight: extendedClasses?.mediaHeight || '',
                    contentBox: extendedClasses?.contentBox || 'lg:py-8 lg:px-6',
                    titleStyle: `font-bold my-6 mx-8 text-center md:text-left ${titleFontColor} text-[65px] font-[Rockwell] font-extrabold`,
                    descriptionStyle: `mx-8 text-center md:text-left ${descFontColor} font-proximaNova mb-10 lg:mb-0 text-[20px] font-normal`,
                    eyebrowStyle: `mx-8 mt-4 text-center md:text-left text-white`,
                    ctaStyle: {
                        style: `mx-8 my-10  text-center md:text-left` || 'pr-8 mt-10 sm:flex',
                        palette: 'orange',
                    },
                    ctaLabelStyle: extendedClasses?.ctaLabelStyle || '',
                };
            }
            break;
        case 'christie_cookies':
            {
                themeStyles = {
                    mediaHeight: extendedClasses?.mediaHeight || '',
                    contentBox: extendedClasses?.contentBox || 'py-8 px-6',
                    titleStyle: extendedClasses?.title,
                    descriptionStyle: extendedClasses?.description,
                    eyebrowStyle: extendedClasses?.eyebrow,
                    ctaStyle: {
                        style: extendedClasses?.cta || 'pr-8 mt-10 sm:flex',
                        palette: 'primary',
                    },
                    ctaLabelStyle: extendedClasses?.ctaLabelStyle || '',
                };
            }
            break;
        default:
            themeStyles = {
                mediaHeight: extendedClasses?.mediaHeight || '',
                contentBox: extendedClasses?.contentBox || 'py-8 px-6',
                titleStyle: extendedClasses?.title,
                descriptionStyle: extendedClasses?.description,
                eyebrowStyle: extendedClasses?.eyebrow,
                ctaStyle: {
                    style: extendedClasses?.cta || 'pr-8 mt-10 sm:flex',
                    palette: 'primary',
                },
                ctaLabelStyle: extendedClasses?.ctaLabelStyle || '',
            };
            break;
    }
    const RightPanel = ({ media }) => {
        if (backgroundLinkRightPanel) {
            return ((0, jsx_runtime_1.jsx)(ReferenceLink_1.ReferenceLink, { link: backgroundLinkRightPanel || {
                    name: 'unknown',
                    reference: {
                        type: 'link',
                        link: '#',
                        target: '_self',
                        openInNewWindow: false,
                    },
                }, component: (linkProps) => ((0, jsx_runtime_1.jsx)("a", { href: linkProps.href, className: (0, classNames_1.cn)('aspect-w-1', 'aspect-h-1', 'lg:aspect-w-3', 'lg:aspect-h-2', backgroundLinkRightPanel ? 'cursor-pointer' : '', alignImageRight ? 'order-2' : 'order-1', themeStyles?.mediaHeight), children: (0, jsx_runtime_1.jsx)(MediaRenderer_1.MediaRenderer, { media: media, component: (mediaProps) => ((0, jsx_runtime_1.jsx)("img", { className: "absolute inset-0 h-full w-full object-cover", src: mediaProps.src, alt: "" })) }) })) }));
        }
        else {
            return ((0, jsx_runtime_1.jsx)("div", { className: (0, classNames_1.cn)('aspect-w-1', 'aspect-h-1', 'lg:aspect-w-3', 'lg:aspect-h-2', backgroundLinkRightPanel ? 'cursor-pointer' : '', alignImageRight ? 'order-2' : 'order-1', themeStyles?.mediaHeight), children: (0, jsx_runtime_1.jsx)(MediaRenderer_1.MediaRenderer, { media: media, component: (mediaProps) => ((0, jsx_runtime_1.jsx)("img", { className: "absolute inset-0 h-full w-full object-cover", src: mediaProps.src, alt: "" })) }) }));
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "grid md:grid-cols-2", style: {
            backgroundColor: bgColor,
        }, children: [(0, jsx_runtime_1.jsx)("div", { className: `flex flex-col justify-center ${alignImageRight ? 'order-1' : 'order-2'}`, children: (0, jsx_runtime_1.jsxs)("div", { className: (0, classNames_1.cn)('relative', 'flex', 'flex-col', 'justify-center', themeStyles?.contentBox), children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, { tagName: "h4", variant: "h4", palette: darkMode ? 'black' : 'none', className: (0, classNames_1.cn)(themeStyles?.eyebrowStyle), children: eyebrow }), title && ((0, jsx_runtime_1.jsx)(Typography_1.Typography, { tagName: "h2", variant: "h2", className: (0, classNames_1.cn)(themeStyles?.titleStyle), palette: darkMode ? 'black' : 'none', children: title })), description && ((0, jsx_runtime_1.jsx)(primitives_richproducts_1.Markdown, { className: (0, classNames_1.cn)(themeStyles?.descriptionStyle), children: description })), (0, jsx_runtime_1.jsx)("div", { className: "flex justify-center space-x-4 md:justify-start", children: callToAction &&
                                callToAction.map((item) => ((0, jsx_runtime_1.jsx)("div", { className: (0, classNames_1.cn)(themeStyles?.ctaStyle?.style), children: darkMode ? ((0, jsx_runtime_1.jsx)(ReferenceLink_1.ReferenceLink, { link: item, component: (linkProps) => ((0, jsx_runtime_1.jsx)(LinkButton_1.LinkButton, { size: "md", palette: themeStyles?.ctaStyle?.palette, shape: "md", href: linkProps.href, target: linkProps.target, className: themeStyles?.ctaLabelStyle, children: linkProps.text })) })) : ((0, jsx_runtime_1.jsx)(ReferenceLink_1.ReferenceLink, { link: item, component: (linkProps) => ((0, jsx_runtime_1.jsx)(LinkButton_1.LinkButton, { size: "md", palette: themeStyles?.ctaStyle?.palette, shape: "md", href: linkProps.href, target: linkProps.target, className: themeStyles?.ctaLabelStyle, children: linkProps.text })) })) }))) })] }) }), media && (0, jsx_runtime_1.jsx)(RightPanel, { media: media })] }));
};
exports.SimpleHeroWithMedia = SimpleHeroWithMedia;
